<!--
  Copyright (C) 2023 Sber

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

          http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.

  Maintainers:
      Vladislav Nefedov <clay.zenx@gmail.com>, Sber

  Contributors:
      Vladislav Nefedov <clay.zenx@gmail.com>, Sber - 2024
      Konstantin Myachin <kvmyachin@gmail.com>, Sber - 2026

-->

<template>
  <div v-bind:class="$style.menu">
    <svg
      viewBox="0 0 252 252"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs />
      <circle
        id="Oval 30"
        cx="126.000000"
        cy="126.000000"
        r="126.000000" />
      <circle
        id="Oval 30"
        cx="126.000000"
        cy="126.000000"
        r="120.000000"
        stroke="currentColor"
        stroke-opacity="1.000000"
        stroke-width="12.000000" />
      <circle
        id="Oval 31"
        cx="57.000000"
        cy="87.000000"
        r="9.000000"
        fill="currentColor"
        fill-opacity="1.000000" />
      <rect
        id="Rectangle 327051"
        x="74.000000"
        y="78.000000"
        rx="9.000000"
        width="130.000000"
        height="18.000000"
        fill="currentColor"
        fill-opacity="1.000000" />
      <circle
        id="Oval 31"
        cx="57.000000"
        cy="126.000000"
        r="9.000000"
        fill="currentColor"
        fill-opacity="1.000000" />
      <rect
        id="Rectangle 327051"
        x="74.000000"
        y="117.000000"
        rx="9.000000"
        width="130.000000"
        height="18.000000"
        fill="currentColor"
        fill-opacity="1.000000" />
      <circle
        id="Oval 31"
        cx="57.000000"
        cy="166.000000"
        r="9.000000"
        fill="currentColor"
        fill-opacity="1.000000" />
      <rect
        id="Rectangle 327051"
        x="74.000000"
        y="157.000000"
        rx="9.000000"
        width="130.000000"
        height="18.000000"
        fill="currentColor"
        fill-opacity="1.000000" />
    </svg>
  </div>
</template>

<script>
  export default {};
</script>

<style module>
.menu {
  padding: 4px;
  border-radius: 17px;
  width: 36px;
  height: 36px;
  color: var(--dh-on-primary);
}
</style>
